import { type FC, useMemo } from 'react'

import { useUnit } from 'effector-react'

import {
  $hasMore,
  $stats,
  fetchNormalMassMessagesPageFx,
} from '@/modules/chatting/ui/sidebar/mass-messages-statistics/models/normalMassMessagesStats.ts'
import { useFetchTeamTable } from '@/modules/team/hooks/use-fetch-team-table.tsx'

import { StatsTable } from './components/StatsTable.tsx'
import { getStatsTableColumns } from './components/getStatsTableColumns.tsx'

export interface Props {}

export const RegularStatsTable: FC<Props> = () => {
  const isFetching = useUnit(fetchNormalMassMessagesPageFx.pending)
  const hasMore = useUnit($hasMore)
  const stats = useUnit($stats)
  const { data: members, isFetching: isMembersFetching } = useFetchTeamTable({
    refetchInterval: 120000,
  })
  const columns = useMemo(
    () => getStatsTableColumns(members, isMembersFetching),
    [isMembersFetching, members],
  )

  return (
    <StatsTable
      columns={columns}
      data={stats}
      onLoadMore={fetchNormalMassMessagesPageFx}
      canLoadMore={hasMore && !isFetching}
      isLoading={isFetching && !stats.length}
      isLoadingMore={isFetching && !!stats.length}
    />
  )
}
